(function () {
  const STORAGE_KEY = "geo_ip_redirect_dismissed";

  const SITE_URLS = {
    US: "https://awolvision.com/",
    DE: "https://awolvision.de/",
    FR: "https://awolvision.fr/",
    UK: "https://awolvision.uk/",
    JP: "https://awolvision.jp/",
  };

  const EUROPEAN_COUNTRY_CODES = new Set([
    "AD", "AL", "AT", "BA", "BE", "BG", "BY", "CH", "CY", "CZ", "DE", "DK",
    "EE", "ES", "FI", "GR", "HR", "HU", "IE", "IS", "IT", "LI", "LT", "LU",
    "LV", "MC", "MD", "ME", "MK", "MT", "NL", "NO", "PL", "PT", "RO", "RS",
    "SE", "SI", "SK", "SM", "UA", "VA", "XK",
  ]);

  const DISABLED_PATH_KEYWORDS = ["luxvision-4k-120hz-ust-projector"];

  const HOST_SITE_MAP = [
    { host: "awolvision.fr", site: "FR" },
    { host: "awolvision.uk", site: "UK" },
    { host: "awolvision.jp", site: "JP" },
    { host: "awolvision.de", site: "DE" },
    { host: "awolvision.com", site: "US" },
  ];

  const getAdminBaseUrl = () => window.adminBaseUrl || "admin.awolvision.com";

  const getGeoIpApiUrl = () =>
    `https://${getAdminBaseUrl()}/prod-api/system/showrooms/geoIpCity`;

  const getCurrentSiteKey = () => {
    const hostname = window.location.hostname;

    const matchedSite = HOST_SITE_MAP.find((item) => hostname.includes(item.host));

    return matchedSite ? matchedSite.site : "US";
  };

  const getTargetSiteByCountry = (countryCode) => {
    const code = (countryCode || "").toUpperCase();

    if (code === "FR") {
      return "FR";
    }

    if (code === "GB") {
      return "UK";
    }

    if (code === "JP") {
      return "JP";
    }

    if (EUROPEAN_COUNTRY_CODES.has(code)) {
      return "DE";
    }

    return "US";
  };

  const isDisabledPage = () => {
    const pathname = window.location.pathname.toLowerCase();

    return DISABLED_PATH_KEYWORDS.some((keyword) => pathname.includes(keyword));
  };

  const hasDismissedInSession = () =>
    window.sessionStorage.getItem(STORAGE_KEY) === "true";

  const markDismissedInSession = () => {
    window.sessionStorage.setItem(STORAGE_KEY, "true");
  };

  const injectBannerStyles = () => {
    if (document.getElementById("geo-ip-redirect-styles")) {
      return;
    }

    const style = document.createElement("style");

    style.id = "geo-ip-redirect-styles";
    style.textContent = `
      .geo_ip_redirect_bar {
        position: fixed;
        left: 0;
        right: 0;
        bottom: 0;
        z-index: 10000;
        padding: 16px 24px;
        background: #f5f5f5;
        border-top: 1px solid rgba(0, 0, 0, 0.08);
        box-shadow: 0 -4px 20px rgba(0, 0, 0, 0.06);
      }

      .geo_ip_redirect_bar__inner {
        display: flex;
        align-items: center;
        justify-content: space-between;
        gap: 24px;
        width: 100%;
        max-width: 1280px;
        margin: 0 auto;
      }

      .geo_ip_redirect_bar__message {
        margin: 0;
        flex: 1;
        font-size: 14px;
        line-height: 1.5;
        color: #1a1a1a;
      }

      .geo_ip_redirect_bar__actions {
        display: flex;
        align-items: center;
        gap: 12px;
        flex-shrink: 0;
      }

      .geo_ip_redirect_bar__actions .button {
        min-width: 120px;
        letter-spacing: 0;
        text-transform: none;
        font-size: 14px;
        line-height: 40px;
        padding: 0 24px;
      }

      .geo_ip_redirect_bar__actions .button--outline {
        background: #fff;
        color: #1a1a1a;
        border: 1px solid #1a1a1a;
      }

      .geo_ip_redirect_bar__actions .button--outline:hover {
        background: #f0f0f0;
      }

      .geo_ip_redirect_bar__actions .button--primary {
        --button-background: 0, 229, 227;
        --button-text-color: 0, 0, 0;
        background: #00e5e3;
        color: #000;
        border: 1px solid #00e5e3;
      }

      .geo_ip_redirect_bar__actions .button--primary:hover {
        background: #00c9c7;
        border-color: #00c9c7;
      }

      .geo_ip_redirect_bar__close {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 42px;
        height: 42px;
        margin-left: 4px;
        padding: 0;
        border: none;
        background: rgba(0, 0, 0, 0.06);
        color: #666;
        font-size: 18px;
        line-height: 1;
        cursor: pointer;
        transition: background 0.2s ease, color 0.2s ease;
      }

      .geo_ip_redirect_bar__close:hover {
        background: rgba(0, 0, 0, 0.12);
        color: #1a1a1a;
      }

      @media screen and (max-width: 750px) {
        .geo_ip_redirect_bar {
          padding: 16px;
        }

        .geo_ip_redirect_bar__inner {
          flex-direction: column;
          align-items: flex-start;
          gap: 16px;
        }

        .geo_ip_redirect_bar__actions {
          width: 100%;
          flex-wrap: wrap;
        }

        .geo_ip_redirect_bar__actions .button {
          flex: 1;
          min-width: 0;
        }

        .geo_ip_redirect_bar__close {
          margin-left: auto;
        }
      }
    `;

    document.head.appendChild(style);
  };

  const showRedirectBanner = () => {
    return new Promise((resolve) => {
      injectBannerStyles();

      const banner = document.createElement("div");

      banner.className = "geo_ip_redirect_bar";
      banner.setAttribute("role", "dialog");
      banner.setAttribute("aria-modal", "false");
      banner.setAttribute("aria-labelledby", "geo-ip-redirect-message");
      banner.innerHTML = `
        <div class="geo_ip_redirect_bar__inner">
          <p class="geo_ip_redirect_bar__message" id="geo-ip-redirect-message">
            This site doesn't match your current location. Would you like to switch?
          </p>
          <div class="geo_ip_redirect_bar__actions">
            <button type="button" class="button button--outline" data-action="stay">Continue Here</button>
            <button type="button" class="button button--primary" data-action="switch">Switch Now</button>
            <button type="button" class="geo_ip_redirect_bar__close" data-action="close" aria-label="Close">&times;</button>
          </div>
        </div>
      `;

      const closeBanner = (confirmed) => {
        banner.remove();
        resolve(confirmed);
      };

      banner.querySelector('[data-action="stay"]').addEventListener("click", () => {
        closeBanner(false);
      });

      banner.querySelector('[data-action="close"]').addEventListener("click", () => {
        closeBanner(false);
      });

      banner.querySelector('[data-action="switch"]').addEventListener("click", () => {
        closeBanner(true);
      });

      document.body.appendChild(banner);
    });
  };

  const fetchGeoIpCountryCode = async () => {
    const response = await fetch(getGeoIpApiUrl(), {
      method: "GET",
    });

    if (!response.ok) {
      throw new Error(`geoIpCity request failed: ${response.status}`);
    }

    const data = await response.json();
    const countryCode = data?.country?.iso_code;

    if (!countryCode) {
      throw new Error("geoIpCity response missing country.iso_code");
    }

    return countryCode;
  };

  const initGeoIpSiteRedirect = async () => {
    try {
      if (isDisabledPage() || hasDismissedInSession()) {
        return;
      }

      const countryCode = await fetchGeoIpCountryCode();
      const currentSiteKey = getCurrentSiteKey();
      const targetSiteKey = getTargetSiteByCountry(countryCode);

      if (currentSiteKey === targetSiteKey) {
        return;
      }

      const confirmed = await showRedirectBanner();

      if (confirmed) {
        window.location.href = SITE_URLS[targetSiteKey];
        return;
      }

      markDismissedInSession();
    } catch (error) {
      console.error("[geo-ip-site-redirect]", error);
    }
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initGeoIpSiteRedirect);
  } else {
    initGeoIpSiteRedirect();
  }
})();
